import { Text } from "@fluentui/react";
import { Delete24Regular } from "@fluentui/react-icons";

import styles from "./ClearChatButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
    isDarkMode?: boolean;
}

export const ClearChatButton = ({ className, disabled, onClick, isDarkMode }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled}`} onClick={onClick}>
            <Delete24Regular />
            <Text className={isDarkMode ? styles.textDark : styles.text}>{"Clear chat"}</Text>
        </div>
    );
};
